<template>
    <div>

        <v-scale-transition>
            <v-switch
                    color="primary"
                    v-model="mobile"
                    label="Mobile friendly"
                    class="mt-0"
                    @change="mobileChanged"
                    :hide-details="true"
            ></v-switch>
        </v-scale-transition>

        <v-scale-transition>
            <v-switch
                    color="primary"
                    v-model="tablet"
                    label="Tablet friendly"
                    @change="tabletChanged"
                    :hide-details="true"
            ></v-switch>
        </v-scale-transition>

        <v-scale-transition>
            <v-switch
                    color="primary"
                    v-model="desktop"
                    label="Desktop / laptop friendly"
                    @change="desktopChanged"
                    :hide-details="true"
            ></v-switch>
        </v-scale-transition>
    </div>

</template>

<script>

    const fields = ['mobile_friendly', 'tablet_friendly', 'desktop_friendly'];

    export default {

        props: {
            data: {
                type: Object,
                required: true,
                validator: (data) => {
                    const keys = Object.keys(data);
                    const result = fields.filter(name => keys.includes(name));
                    return result.length === 3;
                }
            }
        },

        mounted() {
            this.buildModels();
        },

        watch: {
            data() {
                this.buildModels();
            }
        },

        data() {
            return {
                mobile: true,
                tablet: true,
                desktop: true,
            }
        },

        methods: {

            buildModels() {
                if (this.data.mobile_friendly !== null) this.mobile = this.data.mobile_friendly;
                if (this.data.tablet_friendly !== null) this.tablet = this.data.tablet_friendly;
                if (this.data.desktop_friendly !== null) this.desktop = this.data.desktop_friendly;
            },

            mobileChanged(bool) {
                if (!this.nothingChecked()) {
                    this.mobile = bool;
                    this.emit();
                }
            },

            tabletChanged(bool) {
                if (!this.nothingChecked()) {
                    this.tablet = bool;
                    this.emit();
                }
            },

            desktopChanged(bool) {
                if (!this.nothingChecked()) {
                    this.desktop = bool;
                    this.emit();
                }
            },

            nothingChecked() {
                if (!this.mobile && !this.tablet && !this.desktop) {
                    Bus.$emit('flash-message', {type: 'error', message: 'One device must be selected'});
                    return true;
                }

                return false;
            },

            emit() {
                this.$emit('change', {
                    mobile_friendly: this.mobile,
                    tablet_friendly: this.tablet,
                    desktop_friendly: this.desktop,
                });
            }
        }
    }
</script>
